import httpClient from 'src/api/interceptor';
import { LoginForm, ProfileForm, ProfileModel } from 'src/types/auth';
import { UserModel } from 'src/types/user';

export const _AuthApi = {
  login: async (data: LoginForm) => {
    const response = await httpClient.post<UserModel>('/login', data);
    return response.data;
  },
  logout: async () => {
    await httpClient.get('/logout');
  },
  getProfile: async () => {
    const response = await httpClient.get<ProfileModel>('/profile');
    return response.data;
  },
  updateProfile: async (data: ProfileForm) => {
    const response = await httpClient.post('update-profile', data);
    return response.data;
  }
};
